import { AllasStandaloneList } from '@/allas/components/List';
import { LabradorComponent } from '@/types/component';

export const AllasLabradorList: LabradorComponent = ({ data }) => {
  return <AllasStandaloneList items={data.items} as={data.tag} />;
};

export default AllasLabradorList;
